<template>
  <div id="header">
    <a href="#" class="logo pull-left"></a>

    <a href="#" class="pull-left blue-bg">Support</a>
    <a href="#" class="pull-left">Webbmail</a>
    <a href="#" class="pull-left">Senaste projekt</a>

    <a href="tel:+46650540780" class="pull-right narrow">0650 - 540 780</a>
    <a href="mailto:office@atellus.se" class="pull-right narrow blue-color">office@atellus.se</a>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style lang="scss">
@import "./src/util";

#header {
  height: $header_height;

  &:after {
    content: ' ';
    clear: both;
  }

  .logo {
    display: block;
    width: $logo_width;
    height: $logo_height;
    margin: 14px 49px 21px;
    padding: 0px;

    background: url('../assets/logo.png') center center no-repeat;
    background-size: $logo_width $logo_height;

    @include if-retina(){
      background: url('../assets/logo-2x.png') center center no-repeat;
      background-size: $logo_width $logo_height;
    }
  }

  a {
    display: block;
    padding: ($header_height/2 - $header_link_lineheight/2) $header_link_padding;
    color: $header_link_color;
    text-decoration: none;

    &.blue-bg {
      background: $cl_blue;
    }

    &.blue-color {
      color: $cl_blue;
    }

    &.narrow {
      padding-left: $header_link_padding / 2;
      padding-right: $header_link_padding / 2;
    }

    &:hover,
    &:focus,
    &:active {
      color: $header_link_hover;
    }
  }

  .pull-left {
    float: left;
  }

  .pull-right {
    float: right;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue